import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import { SHIPPING_LIST } from '../../../../reusable-components/datagrid/vendorColumns';
import { getVendorDatesData } from '../../../../api/vendors';
import { useSelector } from '../../../../redux/store';

export default function ListViewGrid() {
  const { data: { facilities, vendors }, openModal } = useSelector((state) => state.vendors);

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (openModal) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getVendorDatesData(null, 0);
        setEvents(response.data.map((date) => ({
          ...date,
          facility: facilities.find((facility) => facility.value === date.facilityId)?.label || '',
          vendor: vendors.find((vendor) => vendor.id === date.vendorId)?.name || '',
        })));
      } catch (error) {
        enqueueSnackbar("Error fetching event data", { variant: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [openModal, facilities, vendors]);

  return <Grid item xs={12}>
    <CustomDataGrid
      gridId="vendors-shipping-list"
      boxSX={{ height: 'calc(100vh - 200px)' }}
      data={events}
      gridColumns={[...SHIPPING_LIST]}
      isLoading={loading}
      sort={[{ field: 'facility', sort: 'asc' }]}
    />
  </Grid>;
}
